import React from 'react'
import { Field } from 'formik'

import { TextField, TextArea, Select } from '@/components/forms/formik'
import { MultiSelect } from '@/components/forms/formik/MultiSelect'

export const SetupPage = ({ voiceAgentOptions, contactListOptions }) => {
  return (
    <div className="field-stack">
      <h3>Setup</h3>
      <Field
        name="name"
        label="Campaign Name"
        placeholder="Enter campaign name"
        component={TextField}
        required
        data-testid="campaign-name-field"
      />
      <Field
        name="description"
        label="Description"
        placeholder="Enter campaign description"
        component={TextArea}
        data-testid="campaign-description-field"
      />
      <Field
        name="voice_agent_id"
        label="AI Agent"
        placeholder="Select an AI agent..."
        options={voiceAgentOptions}
        component={Select}
        required
        touchOnChange
        data-testid="voice-agent-select"
      />
      <Field
        name="contact_list_ids"
        label="Contact Lists"
        placeholder="Select contact lists..."
        options={contactListOptions}
        component={MultiSelect}
        condenseOptions={false}
        data-testid="contact-list-select"
      />
    </div>
  )
}
